export default "/assets/markers/driver_hover.png"